<template>
<el-dialog class="editDialog" title="指派" :visible.sync="visible" :destroy-on-close="true" :close-on-click-modal="false" @close="cancel">
  <template v-if="visible">
    <section>
      <el-form ref="form1" :model="form1" :rules="rule">
        <el-form-item label="处理部门:" prop="nextDept">
          <nextCompany @changeCompany="changeCompany"></nextCompany>
        </el-form-item>

        <el-form-item label="处理人员:" prop="nextEmp" v-show="form1.nextDept">
          <el-select class="darkSelect" v-model="form1.nextEmp" filterable default-first-option placeholder="" style="width:auto;" v-loading="preLoading" :popper-append-to-body="false">
            <el-option v-for="item in nextEmp" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="隐患等级：" prop="riskLevel">
          <el-select class="darkSelect" :popper-append-to-body="false" v-model="form1.riskLevel" filterable default-first-option placeholder="请选择" style="width:auto;">
            <el-option v-for="item in yhdj" :key="item.label" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注信息：" prop="remark">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form1.remark" maxlength="150">
          </el-input>
        </el-form-item>

      </el-form>
    </section>

    <div slot="footer" class="dialog-footer">

      <el-button class="cancelButton" type="primary" @click="cancel">取消</el-button>
      <el-button class="confirmButton" type="primary" @click="submit">保存</el-button>
    </div>
  </template>
</el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  descriptor
} from "utils"
export default {
  props: {
    row: {

    },
    pVisible: {
      type: Boolean
    }
  },
  data() {
    return {
      form1: {
        opt: 3
      },
      visible: false,
      preLoading: true,
      nextEmp: []
    }
  },
  components: {
    nextCompany: () => import("public/nextCompany")
  },
  computed: {
    ...mapGetters("Dictionary", ["yhdj"]),
    rule() {
      let that = this;
      return {

        nextDept: descriptor(new Map([
          [true, "请选择下级部门"]
        ]), "blur"),

        nextEmp: descriptor(new Map([
          [true, "请选择处理人员"]
        ]), "blur"),

        yhdj: descriptor(new Map([
          [true, "请选择隐患等级"]
        ]), "blur"),
      }
    }
  },
  methods: {
    resetForm() {
      this.form1 = {
        opt: 3
      };
    },
    changeCompany(v) {
      this.$set(this.form1, 'nextDept', v);
      this.$set(this.form1, 'nextEmp', '');
      this.preLoading = true;
      this.$axiosget(`operation/empApi/findUser`, {
        params: {
          dept_id: this.form1.nextDept
        }
      }).then(res => {
        this.preLoading = false;
        if (!res.data.data) return;
        this.nextEmp = res.data.data;
      })
    },
    submit() {
      this.$refs['form1'].validate(valid => {
        if (valid) {
          this.$axiospost('/operation/risk_flow/new', {
            ...this.form1,
            flowId: this.row.flowId
          }).then(res => {
            this.$message({
              showClose: true,
              message: '提交成功',
              type: 'success'
            });
            this.$emit('cancel');
          })
        }
      })
    },
    cancel() {
      this.$emit('cancel');
    }
  },
  mounted() {},
  watch: {
    pVisible(n) {
      this.visible = n;
      if (n) {
        this.resetForm();
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/yinhuan/mine/more/zhipai.vue